import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { CircularLoader } from '../CircularLoader';
import styles from './PullToRefreshIndicator.module.scss';
const LOADER_SIZE_PX = 24;
export function PullToRefreshIndicator(param) {
    let { isRefreshing, testId } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(styles.indicator, {
                [styles.refreshing]: isRefreshing
            }),
            "data-testid": testId,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.spinner,
                children: /*#__PURE__*/ _jsx(CircularLoader, {
                    size: LOADER_SIZE_PX,
                    className: styles.loader
                })
            })
        })
    });
}
